import create from './create'
import list from './list'

const ApiCall = {
  create,
  list
}

export default ApiCall
